import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": {}
}
const callConversionDataSlice = createSlice({
    name:'callConversion',
    initialState,
    reducers:{
        addCallConversion: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default callConversionDataSlice.reducer
export const addCallConversion = callConversionDataSlice.actions.addCallConversion